import { encodeBase64, type ArticleAsset } from "@wedraft/core";
import sampleImage from "../../desktop/public/sample-editorial-image.png?url";

export const SAMPLE = `让一篇文章，拥有舒服的阅读节奏

写作完成之后，排版应该是一件轻松的事。把文章放进 WeDraft，选好模板，再留一点时间读一遍。你可以手工调整，也可以导入 AI 生成的文章包，接着完成最后的检查。

![装满日用品的现代购物车与木制手推车](images/sample-editorial-image.png "图片来源：WeDraft 内置示例")

---

## 1. 让内容保持原来的意思

模板负责字号、颜色和间距。**作者的观点、原文和来源，都应该被完整保留。** 适度强调关键句，读者就能更快找到文章的重点。

> 好的排版，让读者把注意力留给内容。

### 图片与来源，一起保存

点击工具栏的“添加正文图片”，选一张本机图片，并填写来源。导出的文章包会带上原稿、模板和图片，换到另一台电脑也能继续编辑。

- 原稿保留在文章包中
- 图片跟随文章一起移动
- 检查结果对应到原文位置

---

## 2. 从 AI 的结果，接着往下写

让 AI 使用 WeDraft 工具完成排版，拿到文章包后拖入这个网页。你可以修改原稿，也可以直接在右侧微调文字，最后复制到公众号后台。

| 入口 | 用途 | 交付 |
| --- | --- | --- |
| 网页 | 手工编辑与预览 | 正文与文章包 |
| AI 工具 | 自动检查与排版 | 同样的正文与文章包 |

说明：文章在浏览器本地处理；外链图片会访问图片来源。复制之后，请在微信后台确认图片、表格和手机阅读效果。

---

## 参考来源

1. 本文是 WeDraft 内置操作样稿
2. [Markdown 语法说明](https://commonmark.org/help/)
`;

export async function loadSampleAssets(): Promise<ArticleAsset[]> {
  const response = await fetch(sampleImage);
  if (!response.ok) throw new Error("示例图片暂时未能加载，请刷新重试。");
  return [{ path: "images/sample-editorial-image.png", mimeType: "image/png", base64: encodeBase64(new Uint8Array(await response.arrayBuffer())) }];
}
